import { boolPropsToClassNames } from 'common/utils/style.utils';
import {
  StyledResourceType,
  StyledResourceTypeList
} from './ResourceTypeList.style';
import _ from 'lodash';
import Checkbox from 'components/base/Checkbox';
import useResourceTypes from '../../../../useResourceTypes';

const ResourceType = ({ resourceType, isDisabled, isTogglable, onClick }) => {
  const isChecked = isTogglable ? !isDisabled : true;
  return (
    <StyledResourceType
      className={boolPropsToClassNames({ isDisabled })}
      data-cy={`excluded-types-${resourceType?.name}`}
    >
      <Checkbox disabled={!isTogglable} checked={isChecked} onClick={onClick} />
      {resourceType.name}
    </StyledResourceType>
  );
};

export const ResourceTypeList = ({ excludedTypes, toggleExcludedType }) => {
  const { resourceTypes } = useResourceTypes({ withExcluded: true });
  const nativeResourceTypes = _.omitBy(
    resourceTypes,
    ({ isNative }) => !isNative
  );
  const resourceTypesOrdered = _.orderBy(nativeResourceTypes, 'isTogglable');

  return (
    <StyledResourceTypeList>
      {_.map(resourceTypesOrdered, resourceType => (
        <ResourceType
          key={resourceType.key}
          resourceType={resourceType}
          isDisabled={excludedTypes.includes(resourceType.key)}
          isTogglable={resourceType.isTogglable}
          onClick={() =>
            resourceType.isTogglable && toggleExcludedType(resourceType.key)
          }
        />
      ))}
    </StyledResourceTypeList>
  );
};
